<div class="preview-container">
  <div class="preview-product">
    <div class="preview-image"></div>
    <div class="preview-details">
      <div class="preview-title"></div>
      <div class="preview-price"></div>
      <button class="preview-button">Add to cart</button>
    </div>
  </div>
</div>
